import React from 'react'
import {Divider, Icon, Layout, Tooltip} from "antd";

import _ from 'lodash'
import videoService from '../../services/shared.video.service'
import PublicLayout from '../../layout/PublicLayout'
import SmallVideo from "../SmallVideo";
import ModalCarousel from "../ModalCarousel";
import SharedLoginModal from "../../commons/SharedLoginModal";
const {Content } = Layout

class SharedVideosView extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
           videos: [],
           showLoginModal: true,
           selectedVideos: [],
           folderPath: 'Videos',
            carouselVisible: false,
            token: null,
        }

    }

    componentDidMount() {

        console.log("location:", this.props.location.pathname);
        const pathname = this.props.location.pathname;
        const idx = pathname.lastIndexOf('/');
        const token = pathname.substr(idx + 1);
        console.log("token:", token);

        this.setState({
            token: token
        });

        this.loadVideos(token)
    }

    getSelectedVideoIndex = () => {
        if (this.state.selectedVideos.length == 1) {
            const selected = this.state.selectedVideos[0].props.file
            return _.findIndex(this.state.videos, p => p._id == selected._id)
        }
        return 0
    }

    removeHighlight = () => {
        this.state.selectedVideos.forEach(c => c.setHighlight(false))
        this.state.selectedVideos = []
    }

    handleOnSelectVideo = component => {
        if (!this.ctrlKey) {
            this.removeHighlight()
        }
        component.setHighlight(true)

        this.state.selectedVideos.push(component)

        this.setState({selectedVideos: this.state.selectedVideos})

    }

    renderVideoContainer = videos => {
        this.smallVideos = {}
        const list = []
        for (let video of videos) {
            let smallVideo = (
                <SmallVideo
                    key={video._id}
                    file={video}
                    onClick={this.handleOnSelectVideo}
                    onDoubleClick={e => {
                        console.log('double clicking video', e)
                        this.setState({carouselVisible: true})
                    }}
                    ref={e => {
                        this.smallVideos[video._id] = e
                    }}
                    shared={true}
                    token={this.state.token}
                />
            )
            list.push(smallVideo)
        }
        return list
    }

    handleDownload = () => {
        if (this.state.selectedVideos.length == 1) {
            const file = this.state.selectedVideos[0].props.file
            const url = `/api/v1/share/videos/file/download/?fileId=${file._id}&folderPath=${this.state.folderPath}`
            window.open(url);
            //fileDownloadService.download(url, file.originalname)
        }
    }

    loadVideos = (token, jwt) =>{
        videoService.getVideoFolder(token, jwt).then( folder => {
            return videoService.getVideos(folder.folderId,folder.token)
        }).then(data=>{
            this.setState({ videos: data.files})
        }).catch( error => {
            this.setState({error: error})
        })
    }

    login = (username, password) => {
        videoService.login(username, password)
            .then( rsp => {
                console.log('login rsp:', rsp)
                this.setState({showLoginModal: false, error: null})
                this.loadVideos(this.state.token, rsp.jwt)
            })
            .catch(err =>{
                this.setState({error: err, showLoginModal: false})
            })
    }

    render() {
        if ( this.state.error && this.state.error.message === "401"){
            return (
                <PublicLayout>
                    <SharedLoginModal visible={this.state.showLoginModal} onSubmit={this.login} onCancel={() => {
                        this.setState({showLoginModal: false})
                    }}/>
                </PublicLayout>
            )
        }

        return (

            <PublicLayout>

                { this.state.videos.length > 0 ?
                    <div
                        style={{flex: '1 1 auto', display: 'flex', flexDirection: 'column', padding: '0px 30px'}}
                    >
                        <div style={{marginRight:'16px'}}>
                            <div
                                style={{
                                    display: 'inline',
                                    float: 'right',
                                    marginTop: '15px',
                                    marginLeft: '10px',
                                    marginBottom: '15px'
                                }}
                            >
                                <Tooltip placement="bottom" title={'Download video'}>
                                    <Icon
                                        type="download"
                                        onClick={this.handleDownload}
                                        style={{
                                            marginLeft: '20px',
                                            fontSize: '18px',
                                            paddingTop: '10px',
                                        }}
                                    />
                                </Tooltip>
                            </div>
                            <Divider style={{margin: '0px'}}/>
                        </div>
                        <div style={{flex: '1 1 auto', display: 'flex', flexDirection: 'column'}}>
                            <div
                                id="videoContainer"
                                style={{
                                    flex: '1 1 auto',
                                    display: 'flex',
                                    flexDirection: 'column',
                                }}
                            >
                                <Layout>
                                    <Content>
                                        <div>
                                            {this.renderVideoContainer(this.state.videos)}
                                        </div>
                                    </Content>
                                </Layout>
                            </div>
                        </div>
                        <ModalCarousel
                            visible={this.state.carouselVisible}
                            videos={this.state.videos}
                            shared={true}
                            token={this.state.token}
                            initialSlide={this.getSelectedVideoIndex()}
                            onCancel={() => {
                                this.setState({carouselVisible: false})
                            }}
                        />
                    </div>
                    : null
                }
            </PublicLayout>
        )

    }
}

export default SharedVideosView;
